import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/features/services/auth/auth.service';

let signOutInFlight = false;

function isConversellApi(url: string): boolean {
  if (!url || url.startsWith('/')) {
    return url.startsWith('/');
  }
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase();
    const path = parsed.pathname.toLowerCase();
    const href = parsed.href.toLowerCase();
    if (host === 'graph.facebook.com' || host === 'graph.instagram.com') {
      return false;
    }
    if (host === 'admin.conversell.ai') {
      return true;
    }
    if (href.includes('conversell') && href.includes('gateway')) {
      return true;
    }
    if (host === 'localhost' || host === '127.0.0.1') {
      return (
        path.includes('administratormanager') ||
        path.includes('usermanager') ||
        path.includes('botmanager')
      );
    }
    return false;
  } catch {
    return false;
  }
}

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          isConversellApi(req.url) &&
          !signOutInFlight
        ) {
          signOutInFlight = true;
          const auth = this.injector.get(AuthService);
          const router = this.injector.get(Router);
          void auth.doSignout().finally(() => {
            signOutInFlight = false;
            void router.navigate(['/auth/login']);
          });
        }
        return throwError(() => error);
      }),
    );
  }
}
